module.exports = __webpack_public_path__ + "img/logo-footer-1.ce6245cf.png";